import { Button } from '@mantine/core';
import { useHotkeys } from '@mantine/hooks';
import { FC } from 'react';

import { useCalendarStore } from '@/stores/calendarStore.ts';

import { navigateToToday, setCalendarWeekView } from '@/utils/calendarUtils.ts';

import CalendarSettings from './CalendarSettings.tsx';
import CalendarTypeSelector from './CalendarTypeSelector.tsx';
import DateSwitcher from './DateSwitcher.tsx';
import TimelineIntervalSelector from './TimelineIntervalSelector.tsx';

interface Props {
    scrollHorizontally: (direction: 'left' | 'right') => void;
    scrollVertically: (direction: 'up' | 'down') => void;
}

const CalendarNavigation: FC<Props> = ({ scrollHorizontally, scrollVertically }) => {
    const is_week_view_enabled = useCalendarStore((state) => state.is_week_view_enabled);

    const handleToggleView = (): void => {
        setCalendarWeekView(!is_week_view_enabled);
    };

    useHotkeys([
        ['ArrowLeft', (): void => scrollHorizontally('left')],
        ['ArrowRight', (): void => scrollHorizontally('right')],
        ['ArrowUp', (): void => scrollVertically('up')],
        ['ArrowDown', (): void => scrollVertically('down')],
    ]);

    return (
        <div className="flex flex-grow items-center justify-end gap-8 xl:gap-16">
            <div className="flex items-center justify-between gap-4">
                <Button variant="outline" onClick={navigateToToday}>
                    Heute
                </Button>
                <TimelineIntervalSelector />
                <DateSwitcher />
            </div>
            <div className="flex items-center justify-end gap-4">
                <CalendarTypeSelector handleToggle={handleToggleView} />
                <CalendarSettings />
            </div>
        </div>
    );
};

export default CalendarNavigation;
